import React, { memo } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ArchiveInfo } from './parts/ArchiveInfo';
import { FormPost } from './form/FormPost';

console.log("PostArchivePage");
export const PostArchivePage = memo((props) => {
  const { staff_user, hospitals } = props;

  return (
    <>
      <ToastContainer />
      <div className="alert alert-warning" role="alert">
        <ArchiveInfo />
        <FormPost staff_user={staff_user} hospitals={hospitals} />
      </div>
    </>
  );
});